var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 5.33332H9.33317V3.99999C9.33317 2.15999 7.83984 0.666656 5.99984 0.666656C4.15984 0.666656 2.6665 2.15999 2.6665 3.99999V5.33332H1.99984C1.2665 5.33332 0.666504 5.93332 0.666504 6.66666V13.3333C0.666504 14.0667 1.2665 14.6667 1.99984 14.6667H9.99984C10.7332 14.6667 11.3332 14.0667 11.3332 13.3333V6.66666C11.3332 5.93332 10.7332 5.33332 9.99984 5.33332ZM5.99984 11.3333C5.2665 11.3333 4.6665 10.7333 4.6665 9.99999C4.6665 9.26666 5.2665 8.66666 5.99984 8.66666C6.73317 8.66666 7.33317 9.26666 7.33317  9.99999C7.33317 10.7333 6.73317 11.3333 5.99984 11.3333ZM3.99984 5.33332V3.99999C3.99984 2.89332 4.89317 1.99999 5.99984 1.99999C7.1065 1.99999 7.99984 2.89332 7.99984 3.99999V5.33332H3.99984Z",
    fill: "#5D737E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon_lock.48bfd87ce54fdf116d250da65478f136.svg";
export { ForwardRef as ReactComponent };